<template>
  <FlexTable class="patients-table">
    <b-container>
      <b-row align-h="between">
        <b-col cols="4" class="p-0">
          <b-pagination 
            v-model="currentPage" 
            :total-rows="totalPatients" 
            :per-page="perPage"
            @change="changePage"
            :disabled="isLoading"
          />
        </b-col>
        <b-col cols="4" class="p-0">
          <b-input 
            placeholder="Buscar..."
            v-model="search"
            class="mb-3" 
            debounce="600"
          />
        </b-col>
      </b-row>
      <b-spinner
        class="patients-table-spinner" 
        v-if="isLoading" 
        variant="info" 
        label="Spinning"
        style="width: 4rem; height: 4rem;" 
      />
    </b-container>
    <transition-group name="patients-transition">
      <div
        class="flex-trow"
        v-for="(patient, index) in patients"
        :key="'patient-'+patient.id"
      >
        <div class="remove-patient" @click="showModal(index)">x</div>
        <div class="right-menu">
          <div class="right-menu-btn" @click="showModalEdit(index)">Editar</div>
          <div class="right-menu-btn" @click="goToPatient(patient.id)">Ir</div>
        </div>
        <div class="flex-td rut-cell">
          <span v-if="patient.rut">{{patient.rut}}</span>
          <span v-else></span>
        </div>
        <div class="flex-td name-cell">{{patient.first_name}} {{patient.last_name}}</div>
      </div>
    </transition-group>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import patientService from "../../services/patientService";

export default {
  name: "PatientsTable",
  components: { FlexTable },
  props: {
    patients: {
      type: Array,
      default: function() {
        return [];
      }
    },
    perPage: {
      type: Number,
      default: 10
    },
    totalPatients: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      search: ""
    };
  },
  methods: {
    showModal(index) {
      // we must pass object params with all the information
      let patient = this.patients[index];
      const params = {
        title: "Eliminar paciente",
        text:
          'Estas seguro que quieres eliminar al paciente "' +
          patient.first_name +
          " " +
          patient.last_name +
          '"?',
        // we are passing callback method for our confirm button
        onConfirm: () => {
          return this.deletePatient(index);
        }
      };
      // now we can call function that will reveal our modal
      this.$deleteModal.show(params);
    },
    deletePatient: function(index) {
      let PatientId = this.patients[index].id;
      patientService.delete_patient({id: PatientId}).then(
        data => {
          this.$toasted.success(data.message);
          this.$emit("load-page", this.currentPage, this.search)
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    showModalEdit: function(index) {
      let patient = this.patients[index];
      const params = {
        title: "Editar paciente",
        patientData: {
          id: patient.id,
          first_name: patient.first_name,
          last_name: patient.last_name,
          rut: patient.rut,
          email: patient.email
        },
        // we are passing callback method for our confirm button
        onConfirm: patientData => {
          if (
            patientData.first_name.length > 0 &&
            patientData.last_name.length > 0
          ) {
            this.editPatient(patientData);
          } else {
            this.$toasted.error(
              "Debes agregar el nombre y apellido del paciente!"
            );
          }
        },
        confirmText: "Editar"
      };
      this.$patientModal.show(params);
    },
    editPatient: function(patientData) {
      patientService.edit_patient(patientData).then(
        data => {
          this.$toasted.success(data.message);
          this.$emit("load-page", this.currentPage, this.search)
        },
        // eslint-disable-next-line
        error => {
          this.$toasted.error(error.message);
        }
      );
    },
    goToPatient: function(id) {
      this.$router.push({ name: "patient", params: { id: id } });
    },
    changePage: function(pageNumber) {
      this.$emit("load-page", pageNumber, this.search)
    }
  },
  watch: {
    search: function(newSearch, oldSearch) {
      if (newSearch != oldSearch) {
        this.$emit("load-page", 1, this.search)
      }
    }
  }
};
</script>

<style scoped lang="scss">
.patients-table-spinner {
  border-width: 0.5em;
}
.patients-table {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  width: 100%;

  & span {
    width: 100%;
  }
}

.rut-cell {
  max-width: 12rem;
  padding-left: 3rem;
}

.name-cell {
  border-left: 1px solid $gray-500 !important;
}

.flex-trow {
  position: relative;
  border-left: 1px solid $gray-500;
  border-right: 1px solid $gray-500;
  border-bottom: 1px solid $gray-300;

  & .right-menu {
    position: absolute;
    height: 100%;
    right: 0;
    display: flex;

    & .right-menu-btn {
      border-left: 1px solid $gray-500;
      padding: 0.75rem;
      min-width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgb(23, 162, 184);
      color: white;
      height: 100%;
    }

    & .right-menu-btn:hover {
      background-color: rgb(21, 146, 165);
    }
  }

  &:first-child {
    border-top: 1px solid $gray-500;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-top-right-radius: 10px;
    }
  }

  &:last-child {
    border-bottom: 1px solid $gray-500;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-bottom-right-radius: 10px;
    }
  }

  & .remove-patient {
    display: none;
    position: absolute;
    margin: -0.5px;
    height: 100%;
    align-items: center;
    width: 32px;
    justify-content: center;
    color: black;
    background-color: rgba(grey, 0.1);
  }

  &:hover .remove-patient {
    display: flex;
    cursor: pointer;
  }

  &:first-child .remove-patient {
    border-top-left-radius: 10px;
  }

  &:last-child .remove-patient {
    border-bottom-left-radius: 10px;
  }
}

.flex-td {
  justify-content: flex-start;
  text-align: left;
  border: none;
}

.patients-transition-enter-active {
  transition: opacity 0.6s;
}

.patients-transition-leave-active {
  transition: opacity 0s;
}

.patients-transition-enter,
.patients-transition-leave-to {
  opacity: 0;
}

.patients-transition-leave,
.patients-transition-enter-to {
  opacity: 1;
}
</style>